export default __webpack_public_path__ + "static/media/educacion-en-linea.96ec32ea.png";